import { render, staticRenderFns } from "./StatsOrderDialog.vue?vue&type=template&id=0004b653&scoped=true&"
import script from "./StatsOrderDialog.vue?vue&type=script&lang=js&"
export * from "./StatsOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./StatsOrderDialog.vue?vue&type=style&index=0&id=0004b653&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0004b653",
  null
  
)

export default component.exports